import React, { useEffect, useRef, useState } from 'react';
import { usePlaidLink } from 'react-plaid-link';
import { Alert } from '@material-ui/lab';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Checkbox from 'components/forms/Checkbox';
import Button from 'components/shared/Button';
import Loader from 'components/shared/Loader';
import strings from 'strings';
import { Icon } from 'styles';
import './index.scss'
import { cleanPlaidLocalStorage, getPlaidPageConfig } from "../../../actions/plaid";
import { useHistory } from 'react-router-dom';


const t = strings.PLAID

export default function PlaidIntegration(props) {
    const {
        match: { params: { applicantUUID: aid, ownerId: oid, custom: customParam } },
        location,
        plaidLinkToken: token,
        getToken,
        exchangeToken
    } = props
    const history = useHistory();
    const [checked, setChecked] = useState(false)
    const [loading, setLoading] = useState({ authorize: false, success: false })
    // Client branding/texts; null keeps the default page. Also kept in a ref for the Plaid onSuccess closure.
    const [pageConfig, setPageConfig] = useState(null)
    const pageConfigRef = useRef(null)
    const config = {
        onSuccess: (public_token, metadata) => {
            localStorage.setItem('aid', aid);
            setLoading(prev => ({ ...prev, success: true }))
            exchangeToken({ aid, oid, public_token })
                .then(() => {
                    //Cleaning local storage after auth
                    cleanPlaidLocalStorage();
                    redirectToAuthSuccess();
                })
                .finally(() => setLoading(prev => ({ ...prev, success: false })))
        },
        onExit: (err, metadata) => { console.log(err); },
        onEvent: (eventName, metadata) => { console.log(eventName); },
        token,
    };
    const { open, exit, ready } = usePlaidLink(config);
    const customFlag = customParam === 'custom-J8kS2pL5q'
    const redirectToAuthSuccess = () => {
        const state = { plaidPageConfig: pageConfigRef.current }
        if (customFlag){
            history.push({ pathname: '/plaid-auth-success', search: '?custom-J8kS2pL5q', state });
        } else {
            history.push({ pathname: '/plaid-auth-success', state });
        }
    };

    useEffect(() => {
        getPlaidPageConfig({ aid, oid })
            .then(res => {
                if (res) {
                    pageConfigRef.current = res
                    setPageConfig(res)
                }
            })
            .catch(() => {})
    }, [aid, oid])

    useEffect(() => {
        if (token && ready)
            open()

        return () => exit()
    }, [token, ready, exit, open])

    const handleGetToken = () => {
        setLoading(prev => ({ ...prev, authorize: true }))
        localStorage.setItem('aid', aid);
        localStorage.setItem('oid', oid);
        getToken({ aid, oid })
            .finally(() => setLoading(prev => ({ ...prev, authorize: false })))
    }

    const success = location.pathname.includes('success')

    return (
        <div className='d-flex align-items-center justify-content-center vh-100'>
            {loading.success ? <Loader /> :
                <div className='text-center p-5 plaid-wrapper'>
                    {success ?
                        <>
                            <Icon className='d-block' width={166} height={63} folder='menuIcons' fileName='logo.svg' />
                            <Icon className='d-block mt-3' folder='icons' fileName='success.svg' />
                            <h5 className='mt-3 mb-0'>{t.LINK_SUCCESS}</h5>
                            <Alert className='mt-4' icon={<CheckCircleIcon fontSize="inherit" />} severity="success">
                                {t.GREAT_MSG}
                            </Alert>
                        </> :
                        <>
                            <div className='d-flex align-items-center justify-content-center gap-55'>
                                {pageConfig?.logoBase64 ?
                                    <img width={166} height={63} src={pageConfig.logoBase64}
                                         alt={pageConfig.brandName || 'Logo'} style={{ objectFit: 'contain' }}/>
                                : customFlag ?
                                    <>
                                        <img width={166} height={63}
                                             src={"https://roxwrite-public-assets.s3.amazonaws.com/thrivory-logo.svg"}
                                             alt={'Custom SVG'}/>
                                    </>
                                    :
                                    <>
                                        <Icon width={166} height={63} folder='menuIcons' fileName='logo.svg' />
                                    </>
                                }
                                <div className='circles bl' />
                                <div className='circles gr' />
                                <Icon folder='root' fileName='plaid.svg' />
                            </div>
                            <h3 className='mt-5 mb-0'>{pageConfig?.title || t.TITLE}</h3>
                            <div className='sub-title'>{pageConfig?.subTitle || t.SUB_TITLE}</div>
                            <div className='brief'>{pageConfig?.brief || (customFlag ? t.BRIEF_THRIVORY : t.BRIEF)}</div>

                            {customFlag && (
                                <div className='connect-warning-box'>
                                    <div className='connect-warning-header'>
                                        <InfoOutlinedIcon className='connect-warning-icon' />
                                        <span className='connect-warning-title'>{t.CONNECT_ALL_ACCOUNTS_TITLE}</span>
                                    </div>
                                    <p className='connect-warning-text'>
                                        {t.CONNECT_ALL_ACCOUNTS_TEXT_1}<strong>{t.CONNECT_ALL_ACCOUNTS_TEXT_BOLD}</strong>{t.CONNECT_ALL_ACCOUNTS_TEXT_2}
                                    </p>
                                </div>
                            )}

                            <br/><br/>
                            <div className='brief'>
                                {t.LEARN_MORE_PLAID}
                                <span onClick={() => window.open('https://plaid.com/how-we-handle-data/', '_blank')} className='linkLearnMore'>
                                    {t.TEXT_LINK_PLAID} </span>
                            </div>
                            <div className='brief'>
                                {pageConfig?.brandName ? `To learn more about ${pageConfig.brandName} please visit: ` : t.LEARN_MORE_ROXWRITE}
                                <span onClick={() => window.open(pageConfig?.privacyLinkUrl || 'https://roxwrite-new-site.webflow.io/privacy-policy', '_blank')} className='linkLearnMore'>
                                    {pageConfig?.privacyLinkText || t.TEXT_LINK_ROXWRITE}
                                </span>
                            </div>
                            <Checkbox
                                className='checkBox'
                                label={pageConfig?.checkboxLabel || 'I accept the Terms and Conditions'}
                                checked={checked}
                                onChange={setChecked}
                            />
                            <Button loading={loading.authorize} disabled={!checked} onClick={handleGetToken}>{pageConfig?.authorizeButtonLabel || t.AUTHORIZE}</Button>
                        </>}
                </div>}
        </div>
    )
}
